import { gql } from "graphql-tag";

export const ImportLotteryMutation = gql`
  mutation ImportLotteryCSVMutation($id: ID!, $csv: String!, $config: CsvImportConfigInput!) {
    importCsv(id: $id, csv: $csv, config: $config, type: LOTTERY) {
      success
      messages {
        row
        details
      }
    }
  }
`;

export const ImporterConfig = gql`
  query ImporterConfigQuery {
    interestLists {
      id
      name

      organization {
        id
        name
      }
    }
    csvImporterConfig(type: LOTTERY) {
      column
      label
      description
      required
    }
  }
`;
